(function () {
  const yearEl = document.getElementById("mkFooterYear");
  if (yearEl) yearEl.textContent = String(new Date().getFullYear());
})();